import type { Modifier, State } from '@popperjs/core'
import maxSizeModifier from 'popper-max-size-modifier'

export const applyMaxSize: Modifier<'applyMaxSize', State> = {
  name: 'applyMaxSize',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['maxSize'],
  fn({ state }): void {
    const { width, height } = state.modifiersData.maxSize

    state.styles.popper = {
      ...state.styles.popper,
      maxWidth: `${Math.max(250, width)}px`,
      maxHeight: `${Math.max(250, height)}px`,
    }
  },
}

export const maxSize = {
  ...maxSizeModifier,
  options: {
    padding: 40,
  },
}
